module.exports = __webpack_public_path__ + "img/kontakt_3000.b2453825.webp";